<template>
  <b-overlay :show="showOverlay" rounded="sm">
    <div class="application-form">
      <b-container class="modal-custom-title">
        <b-row>
          <b-col md="1">
            <div class="logo-wrapper">
              <img :src="getImgUrl()" :alt="applictionTypeName">
            </div>
          </b-col>
          <b-col md="11">
            <div class="text-wrapper">
              <h1>
                <strong>Neues Gesuch erfassen</strong>
                <span> | Gesuchsdaten</span>
              </h1>
              <h2>{{applictionTypeName}}</h2>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col md="8" sm="12">
            <validation-observer ref="applicationForm" v-slot="{ passes }">
              <b-form @submit.prevent="passes(onSubmit)">
                <b-alert v-model="hasUnknownError" variant="danger">
                  {{ unknownErrorMessage }}
                </b-alert>
                <b-alert variant="danger" show v-if="Object.keys(formErrors).length">
                  {{formErrors}}
                </b-alert>

                <div v-for="tab in json.tabs" :key="tab.tag" :title="tab.title">
                  <div v-for="(formField, index) in tab.formFields" :key="index">
                    <template v-if="tab.tag == 'gesuch'">
                      <h2 class="form-legend-title">{{formField.title}}</h2>
                      <form-group
                        v-for="formGroup in formField.formGroups"
                        :key="formGroup.for"
                        :data="formGroup"
                        :tab="tab.tag"
                      />
                    </template>
                  </div>
                </div>

                <div class="button-wrapper">
                  <guidance
                    :applicationType="finalApplicationType"
                    :communityId="finalCommunityId"
                  />
                  <b-button type="submit" variant="primary" class="mr-3" disabled v-if="isSubmitting">
                    <b-spinner small></b-spinner>
                    Gesuch erfassen
                  </b-button>
                  <b-button type="submit" variant="primary" class="mr-3" v-else>Gesuch erfassen</b-button>
                  <b-button variant="secondary" v-if="modalMethod === 'erstellen'" @click="saveAsDraft">Als Entwurf speichern</b-button>
                  <b-button variant="secondary" v-else-if="modalMethod === 'bearbeiten'" @click="saveAsDraft">Entwurf speichern</b-button>
                </div>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-overlay>
</template>

<script>
  import { mapState } from 'vuex'
  import { ValidationObserver } from 'vee-validate'
  import FormGroup from '@/components/application/Form/FormComponents/FormGroup.vue'
  import { errorHandler } from '@/helpers/formHelper.js'
  import Guidance from '@/components/application/Intro/Guidance.vue'

  export default {
    data: () => ({
      isSubmitting: false,
      isValid: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      formErrors: {},
      json: {},
      showOverlay: true,
      modalMethod: null
    }),
    created () {
      this.getApplicationForm()
      this.$store.commit('application/SET_MODAL_PAGE', 2)
      const { modalMethod } = this.$route.params
      this.modalMethod = modalMethod
    },
    methods: {
      async getApplicationForm () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('application/GET_APPLICATION_FORM').then(res => {
          const { data, errors } = res

          if (errors) {
            this.showOverlay = false
            return errorHandler(this, errors)
          }

          this.json = data.gesuchFormByCode

          if (this.$route.params.modalMethod === 'bearbeiten') {
            this.$store.commit('application/UPDATE_FORMFIELD_VALUE')
          }
          this.showOverlay = false
        }).catch(err => {
          this.showOverlay = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      async onSubmit () {
        this.isSubmitting = true
        const { draftId } = this.$route.params
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('application/SAVE_APPLICATION_FORM', draftId).then(res => {
          const { data, errors } = res

          if (errors) {
            this.isSubmitting = false
            return errorHandler(this, errors)
          }

          this.json = {}
          this.$store.commit('application/RESET_APPLICATION_FORM')

          const { gesuchId } = data.antragCreate.gesuch

          this.isSubmitting = false

          this.$root.$emit('applicationModalClose')
          this.$router.push({
            name: 'application-detail',
            params: {
              applicationId: gesuchId,
              redirectFromModal: true
            }
          }).catch((e) => {})
          /* this.$router
            .push({
              name: 'uebersicht',
              params: {
                modalMethod: 'erstellen',
                tabName: 'abschluss',
                draftId: null,
                gesuchId
              }
            })
            .catch(() => {}) */
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      saveAsDraft () {
        this.$root.$emit('applicationModalComponent')
      },
      getImgUrl () {
        try {
          return require(`@/assets/img/${this.finalApplicationType}.svg`)
        } catch (e) {
          return ''
        }
      }
    },
    computed: {
      ...mapState({
        finalCommunityId: state => state.application.createApplication.finalCommunityId,
        finalApplicationType: state => state.application.createApplication.finalApplicationType,
        applictionTypeName: state => state.application.createApplication.applictionTypeName
      })
    },
    components: {
      FormGroup,
      ValidationObserver,
      Guidance
    }
  }
</script>

<style lang="scss" scoped>
  .application-form{
    margin-top: 1rem;

    & .form-legend-title {
      color: $magenta;
    }
  }
  .button-wrapper{
    padding-right: 1rem;
    margin-bottom: 1rem;

    .btn{
      display: inline-block;
    }
  }
</style>
